import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=a15d927c&scoped=true&"
import script from "./Stats.vue?vue&type=script&lang=ts&"
export * from "./Stats.vue?vue&type=script&lang=ts&"
import style0 from "./Stats.vue?vue&type=style&index=0&id=a15d927c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15d927c",
  null
  
)

export default component.exports